import React, { useEffect, useState } from "react";
import "./Headerads.css";
import axios from "axios";
import { Link } from "react-router-dom";
import HeaderAdsSkeleton from "../SkeletonLoader/HeaderAdsSkeleton";

const Headerads = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [fetchedData1, setFetchedData1] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadAds = async () => {
      setLoading(true);
      try {
        const [topLeftRes, preFooterRes] = await Promise.all([
          axios.get("https://api.dremerz.net/api/Kalanjiyam_Advertisement_TopLeft"),
          axios.get("https://api.dremerz.net/api/Kalanjiyam_Advertisement_Prefooterad1")
        ]);

        setFetchedData(topLeftRes.data);

        const onTop = preFooterRes.data.filter(
          (data) => data.showOnTop === "1"
        );
        setFetchedData1(onTop);

      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    loadAds();
  }, []);

  if (loading) {
    return <HeaderAdsSkeleton />;
  }

  return (
    <div className="container-fluid py-4">
      <div className="row g-3">
        {fetchedData1?.map((item, index) => (
          <div
            key={`${item.id}-${index}`}
            className="col-12 col-sm-6 col-md-6 col-lg-4"
          >
            <div className="row g-3">
              <div className="col-12 leftheaderads-card-container">
                <div className="leftheaderads-card h-100">
                  <Link to={item.banneradtitle}>
                    <img
                      src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                      alt="ads"
                      className="leftheaderads-card-img-top2"
                      loading="lazy"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="col-12 col-sm-6 col-md-6 col-lg-8">
          <div className="leftheaderads-scroll-container">
            <div className="leftheaderads-scroll-content">
              {fetchedData?.map((item) => (
                <div key={item.id} className="leftheaderads-card-container">
                  <div className="leftheaderads-card h-100">
                    <Link to={item.banneradtitle}>
                      <img
                        src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                        alt="ads"
                        className="leftheaderads-card-img-top1"
                        style={{ cursor: "pointer" }}
                        loading="lazy"
                      />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Headerads;